import { render, staticRenderFns } from "./membercard.vue?vue&type=template&id=a37bcb58&scoped=true"
import script from "./membercard.vue?vue&type=script&lang=js"
export * from "./membercard.vue?vue&type=script&lang=js"
import style0 from "./membercard.vue?vue&type=style&index=0&id=a37bcb58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37bcb58",
  null
  
)

export default component.exports